import styled, { css } from 'styled-components';
import { Checkbox } from '@mui/material';
import { THEME } from '../../../../themes';
import { CaptionFont, HeadlineFont, Subtitle1Font } from '../../../../themes/fonts';
import { hexToRgbA } from '../../../../utils/colors';

const ActiveStyle = css`
  border: solid 2px ${THEME.COLORS.ACCENT};
  background-color: ${THEME.COLORS_RGB.ACCENT_012};
  cursor: pointer;
`;

export const Container = styled.div<{ isActive: boolean }>`
  width: 394px;
  height: 56px;
  border-radius: 12px;
  border: solid 1px rgba(19, 15, 53, 0.12);
  background-color: ${THEME.COLORS.LIGHT_GREY};
  padding-left: ${THEME.SPACING.BASE};
  display: flex;
  ${({ isActive }) => isActive ? ActiveStyle : undefined};

  :hover {
    ${ActiveStyle};
  }
`;

export const Emoji = styled.div`
  ${HeadlineFont};
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${THEME.SPACING.BASE};
  height: 100%;
`;

export const Title = styled.div`
  ${Subtitle1Font};
  font-weight: 600;
  height: 16px;
  margin-left: ${THEME.SPACING.BASE};
  color: ${THEME.COLORS.CONTENT_A};
`;

export const Description = styled.div`
  ${CaptionFont};
  height: 12px;
  margin-left: ${THEME.SPACING.BASE};
  color: ${THEME.COLORS.CONTENT_A};
  opacity: ${THEME.OPACITY.MED};
`;

export const StyledCheckbox = styled(Checkbox).attrs({
  sx: {
    color: hexToRgbA(THEME.COLORS.CONTENT_PRIMARY, THEME.OPACITY.LOW),
    '&.Mui-checked': {
      color: THEME.COLORS.ACCENT,
    },
  },
})``;
